import { put, call, all, takeEvery, select } from 'redux-saga/effects'
import * as Actions from 'state/actions'
import * as Selectors from 'state/selectors'
import {
  processSelectorsToPayload
} from './helpers'
import { apiV1, apiV2, buildAxiosRequestConfig } from 'shared/utils/api'
import _ from 'lodash'

function* requestSaga(action) {
  const REQUEST_ACTION_TYPE = `${action.type}_START`
  const SUCCESS_ACTION_TYPE = `${action.type}_SUCCESS`
  const ERROR_ACTION_TYPE = `${action.type}_FAIL`

  try {
    const token = yield select(Selectors.getToken),
          organisationId = yield select(Selectors.getActiveOrganisationId)

    if(!token) throw new Error('Token is missed')

    const axiosRequestConfig = buildAxiosRequestConfig({
      ...action.payload,
      token,
      organisationId
    })

    yield put({ type: REQUEST_ACTION_TYPE })

    const api = action?.payload?.useApiV2 === true ? apiV2 : apiV1
    const response = yield call(api.request, axiosRequestConfig)

    yield put({ type: SUCCESS_ACTION_TYPE, response: response.data })

    /*
    * Handling success meta actions
    * */

    if(
      !Array.isArray(action?.meta?.successActions) &&
      !action?.meta?.successActions?.length
    ) return

    const { successActions } = action.meta

    for(let i = 0; i < successActions.length; i++) {
      const successAction = successActions[i]
      const selectors = Array.isArray(successAction?.selectorsToPayload)
        ? yield call(processSelectorsToPayload, successAction.selectorsToPayload)
        : {}

      const payloadMergeObjects = [
        selectors,
        successAction.provideResponse && { response },
        successAction.provideParentPayload && action.payload,
        typeof successAction.payload === 'object' && successAction.payload
      ]

      yield put({
        type: successAction.type,
        payload: _.merge(...payloadMergeObjects),
        meta: successAction.meta || {}
      })
    }

  } catch (err) {
    console.error('requestSaga :: catch an error', err)
    yield put(Actions.catchApiError(err))
    yield put({ type: ERROR_ACTION_TYPE, error: err })
  }
}

function* prepareSaga(action) {
  const selectors = {}

  for(let i = 0; i < action.meta.selectorsToPayload.length; i++) {
    let ctx = selectors
    const selectorItem = action.meta.selectorsToPayload[i]

    if(Array.isArray(selectorItem?.deepLevel) && selectorItem.deepLevel.length > 0) {

      for(let j = 0; j < selectorItem.deepLevel.length; j++) {
        const keyItem = selectorItem.deepLevel[j]

        if(!ctx[keyItem]) {
          ctx[keyItem] = {}
        }

        ctx = ctx[keyItem]
      }
    }

    ctx[selectorItem.key] = yield select(selectorItem.selector)
  }

  yield put({
    type: action.meta.finalActionType,
    payload: _.merge(action?.payload, selectors),
    meta: action.meta?.meta || {}
  })
}

const isRequestAction = action => /_REQUEST$/.test(action.type)
const isPrepareAction = action => /_PREPARE$/.test(action.type)

export default function* rootSaga() {
  yield all([
    takeEvery(isRequestAction, requestSaga),
    takeEvery(isPrepareAction, prepareSaga)
  ])
}
